/**
 * API Client Configuration
 * RoofMapper v3 - Axios instance with interceptors
 */

import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

import { env } from 'env';
const API_URL = env.API_URL || 'http://localhost:5001';

// Create axios instance
export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 120000, // 120 seconds for large GeoTIFF files
});

// Request interceptor - Add auth token
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('authToken');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Handle 401 Unauthorized
    if (error.response?.status === 401) {
      console.warn('⚠️ Authentication token expired or invalid');
      localStorage.removeItem('authToken');
      
      // Only redirect if not already on auth page
      if (!window.location.pathname.startsWith('/auth')) {
        // Show a brief message before redirecting
        alert('Your session has expired. Please sign in again.');
        window.location.href = '/auth/sign-in';
      }
    }

    // Handle network errors
    if (!error.response) {
      console.error('Network error:', error.message);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
